import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import query from "../../query";
import { TabelType } from "../../types/common";

const useSpecial = (sport: string, table: TabelType, provider?: string) => {
  const [focusMatchId, setFocusMatchId] = useState<string>("");
  const specialFootballFeedQuery = query.specialPricesFeed(
    sport,
    Number(focusMatchId),
    table,
    provider,
  );
  const specialFootballFeed = useQuery(
    specialFootballFeedQuery.key,
    specialFootballFeedQuery.queryFn,
    {
      refetchInterval: 10000,
      enabled: !!focusMatchId,
    },
  );
  const format = (data: any) =>
    data &&
    Object.keys(data)?.reduce((total, key) => {
      let value: {
        label: string;
        outcomeId?: string;
        price?: number | string;
        sp?: string;
        marketId?: string;
        matchId: string;
      }[] = [];
      switch (key) {
        case "dc":
          value = [
            {
              label: "1X",
              outcomeId: data?.dc?.och,
              price: Number(data?.dc?.["1x"])?.toFixed(2),
              sp: "",
              marketId: data?.dc?.mkid,
              matchId: focusMatchId,
            },
            {
              label: "12",
              outcomeId: data?.dc?.ocd,
              price: Number(data?.dc?.["12"])?.toFixed(2),
              sp: "",
              marketId: data?.dc?.mkid,
              matchId: focusMatchId,
            },
            {
              label: "X2",
              outcomeId: data?.dc?.oca,
              price: Number(data?.dc?.["x2"])?.toFixed(2),
              sp: "",
              marketId: data?.dc?.mkid,
              matchId: focusMatchId,
            },
          ];
          break;

        case "oe":
          value = [
            {
              label: "Odd",
              outcomeId: data?.oe?.oco,
              price: data?.oe?.o,
              sp: "",
              marketId: data?.oe?.mkid,
              matchId: focusMatchId,
            },
            {
              label: "Even",
              outcomeId: data?.oe?.oce,
              price: data?.oe?.e,
              sp: "",
              marketId: data?.oe?.mkid,
              matchId: focusMatchId,
            },
          ];
          break;

        case "yn":
        case "awn":
        case "hwn":
          value = [
            {
              label: "Yes",
              outcomeId: data?.[key]?.yid,
              price: Number(data?.[key]?.y)?.toFixed(2),
              sp: "",
              marketId: data?.[key]?.mkid,
              matchId: focusMatchId,
            },
            {
              label: "No",
              outcomeId: data?.[key]?.nid,
              price: data?.[key]?.n,
              sp: "",
              marketId: data?.[key]?.mkid,
              matchId: focusMatchId,
            },
          ];
          break;

        case "tob":
        case "tob1st":
        case "hto":
        case "ato":
          value = [
            {
              label: `Over (${data?.[key]?.o})`,
              outcomeId: data?.[key]?.oco,
              price: Number(data?.[key]?.op)?.toFixed(2),
              sp: data?.[key]?.sp,
              marketId: data?.[key]?.mkid,
              matchId: focusMatchId,
            },
            {
              label: `Under (${data?.[key]?.u})`,
              outcomeId: data?.[key]?.ocu,
              price: Number(data?.[key]?.up)?.toFixed(2),
              sp: data?.[key]?.sp,
              marketId: data?.[key]?.mkid,
              matchId: focusMatchId,
            },
          ];
          break;
        case "1h/cr":
        case "2h/cr":
        case "cr":
          value =
            data?.[key]?.d?.map((each: any) => ({
              label: each.s,
              outcomeId: each.ocid,
              price: Number(each.p)?.toFixed(2),
              sp: "",
              marketId: data?.[key]?.mkid,
              matchId: focusMatchId,
              spd: each.spd,
            })) || [];
          break;
        case "1h/ttg":
        case "ttg":
        case "ht/ft/oe":
        case "ht/ft":
          value =
            data?.[key]?.d?.map((each: any) => ({
              label: each.n,
              outcomeId: each.ocid,
              price: Number(each.p)?.toFixed(2),
              sp: "",
              marketId: data?.[key]?.mkid,
              matchId: focusMatchId,
              spd: each.spd,
            })) || [];
          break;
        default:
          value = [];
          break;
      }

      return { ...total, [key]: value };
    }, {});

  return {
    focusMatchId,
    setFocusMatchId,
    data: format(specialFootballFeed.data?.[0]),
    isLoading: specialFootballFeed.isLoading,
  };
};

export default useSpecial;
